const { trackMelidata } = require('./Tracker');

const pathPrefix = '/checkout_off/payment/select_type/';

const trackBottomSheet = (event = '', tracking, stateConfigs) =>
  trackMelidata({ path: `${pathPrefix}${event}`, payload: { ...tracking.payload } }, stateConfigs);

module.exports = trackBottomSheet;
